import { COLORS } from '@app/constants';
import { GroupList } from '..';
import { FC } from 'react';
import { components, MenuProps } from 'react-select';
import styled from 'styled-components';

const Menu: FC<MenuProps> = ({ children, ...props }) => {
  const { isGroupSelect, currentGroup, setCurrentGroup, groups } =
    props.selectProps;

  return (
    <Root $isMulti={props.isMulti}>
      <components.Menu {...props}>
        {isGroupSelect && (
          <GroupList
            groups={groups}
            currentGroup={currentGroup}
            onChooseGroup={(group) => setCurrentGroup && setCurrentGroup(group)}
          />
        )}
        {children}
      </components.Menu>
    </Root>
  );
};

export default Menu;

interface StyleProps {
  $isMulti: boolean;
}

const Root = styled.div<StyleProps>`
  position: absolute;
  top: 48px;
  left: 0;
  background-color: ${COLORS.white};
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(75, 100, 137, 0.1);
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  z-index: 1;
`;
